<template>
  <a class="prod-item" :href="product.permalink" @click="handleProductUrl">
    <div class="prod-item__img-wrap">
      <img
        v-if="product.images.thumbnail"
        class="prod-item__image"
        :src="product.images.thumbnail"
        alt
      />
    </div>
    <div class="prod-item__tags">
      <div
        v-for="tag in product.tags"
        :key="tag.id"
        class="prod-item__tag"
        :style="{ 'background-color': tag.color }"
      >
        <p>{{ tag.name }}</p>
      </div>
      <div v-if="product.on_sale" class="prod-item__tag prod-item__tag--sale">
        <p>-{{ salePercent }}%</p>
      </div>
    </div>

    <p class="prod-item__price" v-if="product.regular_price_raw > 0.0">
      <del v-if="product.on_sale">
        <span class="woocommerce-Price-amount amount"
          ><bdi v-html="product.regular_price"></bdi
        ></span>
      </del>
      <template v-else>
        <span class="woocommerce-Price-amount amount"
          ><bdi v-html="product.regular_price"></bdi
        ></span>
      </template>
      <ins v-if="product.on_sale"
        ><span class="woocommerce-Price-amount amount"
          ><bdi v-html="product.sale_price"></bdi></span
      ></ins>
      <small class="woocommerce-price-suffix" v-if="product.price_suffix">{{
        product.price_suffix
      }}</small>
    </p>

    <h3 class="prod-item__title" v-html="product.name"></h3>
    <p class="prod-item__desc">{{ product.short_description }}</p>
  </a>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    salePercent() {
      let regular_price = this.product.regular_price_raw;
      let sale_price = this.product.sale_price_raw;

      return Math.ceil(((regular_price - sale_price) / regular_price) * 100);
    }
  },
  methods: {
    handleProductUrl() {
      window.localStorage.setItem("catalogUrl", window.location.hash);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/product/Item.vue